import {
  createActionTypes,
  createAsyncActionTypes,
} from "@dpdgroupuk/redux-action-creator";

export default createActionTypes("AUTH", {
  FETCH_USER: createAsyncActionTypes("FETCH_USER"),
  LOGOUT_USER: createAsyncActionTypes("LOGOUT_USER"),
});
